"use client";

import { motion } from "framer-motion";
import { Row, Col } from 'react-bootstrap';
import { Image } from "react-bootstrap";
import Profile from "../images/pic.webp";

const AboutMe = () => {

    return (
        <Col className="relative isolate mb-20 mt-5 pt-5">
            <Row id="about" className="pt-5 mt-5 mx-auto position-relative d-flex justify-content-center justify-content-lg-start align-items-center align-items-lg-center">
                <Col xxl={4} xl={4} lg={4} md={12} sm={11} xs={11} className="m-center mb-5">
                    <div className="lbrXps flex justify-center md:justify-start lg:mb-0 pl-0 md:pl-3">
                        <motion.div initial={{ opacity: 0, y: -80 }} animate={{ opacity: 1, y: 0 }} transition={{
                            duration: 0.25,
                            ease: "easeOut"
                        }} className="relative isolate wrapper">
                            <Image src={Profile} alt="Profile" className="img-profile" />
                        </motion.div>
                    </div>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={11} xs={11} className="">
                    <div className="pl-0 md:pl-15 lg:pl-20 lg:mt-0 md:mt-0 flex-1 text-main">
                        <motion.div initial={{ opacity: 0, y: -60 }} animate={{ opacity: 1, y: 0 }} transition={{
                            duration: 0.25,
                            ease: "easeOut"
                        }} className="relative isolate wrapper">
                            Hi, my name is
                            <h1 className="text-xl md:text-2xl lg:text-3xl xl:text-5xl uppercase text-white text-title mb-3">
                                Natthida Promma
                            </h1>

                            <h4 className="mb-2 text-main">I love designing and building things that live on the web.</h4>
                            <div className="mb-2 text-dec">My journey into frontend development and UX/UI design began when I started exploring how visual design and code work together. From tweaking layouts in school projects to designing interactive interfaces, I quickly realized how much I enjoy turning ideas into real, user-friendly experiences.</div>
                            <div className="mb-3 text-dec">Whether it's writing clean, responsive code or crafting intuitive UI flows in Figma, I’m always driven by one goal — creating beautiful and functional digital experiences that make users feel right at home.</div>
                        </motion.div>
                    </div>
                </Col>
            </Row>
        </Col>
    );
}
export default AboutMe